export type PlanType = 'free' | 'hobby' | 'pro' | 'team';

export interface PlanLimits {
  maxMaps: number;          // -1 = unlimited
  maxNodesPerMap: number;   // -1 = unlimited
  maxAttachmentsPerMap: number; // -1 = unlimited
  canExportPdf: boolean;
  canExportPng: boolean;
  canCollaborate: boolean;
  canPublish: boolean;
  canUseTemplates: boolean;
  canUseAllLayouts: boolean;
  canUseAllThemes: boolean;
  versionHistoryDays: number; // 0 = none
}

export const PLAN_LIMITS: Record<PlanType, PlanLimits> = {
  free: {
    maxMaps: 5,
    maxNodesPerMap: 100,
    maxAttachmentsPerMap: 0,
    canExportPdf: false,
    canExportPng: true,
    canCollaborate: false,
    canPublish: false,
    canUseTemplates: false,
    canUseAllLayouts: false,
    canUseAllThemes: false,
    versionHistoryDays: 0,
  },
  hobby: {
    maxMaps: 25,
    maxNodesPerMap: 500,
    maxAttachmentsPerMap: 5,
    canExportPdf: true,
    canExportPng: true,
    canCollaborate: false,
    canPublish: false,
    canUseTemplates: true,
    canUseAllLayouts: true,
    canUseAllThemes: true,
    versionHistoryDays: 30,
  },
  pro: {
    maxMaps: -1,
    maxNodesPerMap: -1,
    maxAttachmentsPerMap: -1,
    canExportPdf: true,
    canExportPng: true,
    canCollaborate: true,
    canPublish: true,
    canUseTemplates: true,
    canUseAllLayouts: true,
    canUseAllThemes: true,
    versionHistoryDays: 90,
  },
  team: {
    maxMaps: -1,
    maxNodesPerMap: -1,
    maxAttachmentsPerMap: -1,
    canExportPdf: true,
    canExportPng: true,
    canCollaborate: true,
    canPublish: true,
    canUseTemplates: true,
    canUseAllLayouts: true,
    canUseAllThemes: true,
    versionHistoryDays: 365,
  },
};

export function getPlanLimits(plan: PlanType): PlanLimits {
  return PLAN_LIMITS[plan];
}
